import { defineMessages } from 'react-intl';

export default defineMessages({
  giveFeedbackSuccessTitle: {
    id: 'frontbucket.editorAIFeedbackCollector.success.title',
    description: 'Title shown when feedback is successfully submitted',
    defaultMessage: 'Thanks!',
  },
  giveFeedbackSuccessDescription: {
    id: 'frontbucket.editorAIFeedbackCollector.success.description',
    description: 'Description shown when feedback is successfully submitted',
    defaultMessage:
      'Your valuable feedback helps us continually improve our products.',
  },
  giveFeedbackTitle: {
    id: 'frontbucket.editorAIFeedbackCollector.giveFeedback.title',
    description: 'Title for give feedback modal',
    defaultMessage: 'Help us make Atlassian Intelligence even better',
  },
  giveFeedbackPlaceholder: {
    id: 'frontbucket.editorAIFeedbackCollector.giveFeedback.placeholder',
    description: 'Text for placeholder in give feedback modal',
    defaultMessage:
      'Let us know what you were trying to do and how it could be better',
  },
  supportSiteLinkText: {
    id: 'frontbucket.editorAIFeedbackCollector.supportSiteLink',
    description: 'Link to support site',
    defaultMessage: 'support site',
  },
  canContactLabel: {
    id: 'frontbucket.editorAIFeedbackCollector.canContactLabel',
    description: 'Text for the contact label',
    defaultMessage:
      'Atlassian can contact me about this feedback. See our {privacyPolicyLink}.',
  },
  privacyPolicyLinkText: {
    id: 'frontbucket.editorAIFeedbackCollector.privacyPolicyLink',
    description: 'Link to privacy policy',
    defaultMessage: 'privacy policy',
  },
  enrolLabel: {
    id: 'frontbucket.editorAIFeedbackCollector.enrolLabel',
    description: 'Text for the enrol label',
    defaultMessage:
      "I'd like to help improve Atlassian products by joining the {atlassianResearchGroupLink}.",
  },
  atlassianResearchGroupLinkText: {
    id: 'frontbucket.editorAIFeedbackCollector.atlassianResearchGroupLink',
    description: 'Link to Atlassian Research Group',
    defaultMessage: 'Atlassian Research Group',
  },
  giveFeedbackPromptConsent: {
    id: 'frontbucket.editorAIFeedbackCollector.giveFeedback.promptConsent',
    description:
      'Text for the checkbox to include user prompt and response in feedback',
    defaultMessage: 'Include my last prompt and response in the feedback.',
  },
  giveFeedbackSummaryTitle: {
    id: 'frontbucket.editorAIFeedbackCollector.giveFeedback.summaryTitle',
    description: 'Title for the feedback summary',
    defaultMessage: "What's on your mind?",
  },
});
